import { render, staticRenderFns } from "./board_options.vue.js?vue&type=template&id=3323b6b6&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_options.vue?vue&type=template&id=3323b6b6&vue3"
import script from "./board_options.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_options.vue?vue&type=script&lang=js&vue3"
export * from "./board_options.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./board_options.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports